/**
 * 계층 1 — 코어 타입. DOM·ServiceWorker·fetch 를 참조하지 않는다 (절대 규칙 13).
 *
 * 계약 타입(`Tv2mPushPayload`·`Tv2mLinkContext`·`DeferredLinkResult` …)은 전부
 * `@apm/contracts` 에 있고 여기서 재선언하지 않는다 (절대 규칙 10). 이 파일이 담는 것은
 * **SDK 자신의 구성과 상태**뿐이다.
 */
export const TV2M_PLATFORM_PROFILES = ['native', 'web'];
/** 저장소 키. 값이 바뀌면 기존 설치의 `deviceId` 가 끊기므로 한 곳에 모아 둔다. */
export const TV2M_STORAGE_KEYS = {
    deviceId: 'tv2m.deviceId',
    /** 한 번이라도 초기화를 마쳤는가. 첫 실행 판정의 근거 */
    launched: 'tv2m.launched',
    /** QR 설치 안내에서 받아 둔 세션 토큰. Deferred 복원이 소비한다 */
    installRef: 'tv2m.installRef',
};
//# sourceMappingURL=types.js.map